import { render, staticRenderFns } from "./SolicitacoesTreinamentoTabela.vue?vue&type=template&id=76fc7837"
import script from "./SolicitacoesTreinamentoTabela.vue?vue&type=script&lang=js"
export * from "./SolicitacoesTreinamentoTabela.vue?vue&type=script&lang=js"
import style0 from "./SolicitacoesTreinamentoTabela.vue?vue&type=style&index=0&id=76fc7837&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports